// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";
import { recordExcludingArraysOf } from "@dashboardApi/apis/offerfitShared";

const isPerformanceReportRegime = objectOf({
  key: string,
  display_name: string,
  split_ratio: maybe(number, true),
  prediction_method: maybe(string, true),
  description: maybe(string, true),
});

const isPerformanceReportSegment = objectOf({
  segment_feature: string,
  label: string,
  id: maybe(string, true),
  segment_feature_type: maybe(string, true),
});

const isPerformanceReportMetric = objectOf({
  id: string,
  name: maybe(string, true),
  attributed: maybe(boolean, true),
  description: maybe(string, true),
});

const isPerformanceReportKpi = objectOf({
  id: string,
  name: string,
  has_attributed_metrics: boolean,
  left_metric: maybe(isPerformanceReportMetric, true),
  right_metric: maybe(isPerformanceReportMetric, true),
  operation: maybe(string, true),
  description: maybe(string, true),
  invert_colors_direction: maybe(boolean, true),
  left_aggregation: maybe(string, true),
  right_aggregation: maybe(string, true),
  constant_multiplier: maybe(number, true),
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsResult = objectOf({
  regimes: recordExcludingArraysOf(isPerformanceReportRegime),
  segments: arrayOf(isPerformanceReportSegment),
  kpis: arrayOf(isPerformanceReportKpi),
  features: objectOf({ show_attributed_toggle: boolean }),
  start_date: maybe(string, true),
  data_delay_in_days: maybe(number, true),
  dates_to_exclude: maybe(arrayOf(string), true),
  first_send_date: maybe(string, true),
  partial_personalization_date: maybe(string, true),
  full_personalization_date: maybe(string, true),
  lifetime_total_clicks: maybe(number, true),
});
